import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bell } from 'lucide-react';
const buyers = ['Patricia F. de Santiago del Estero', 'Martín L. de Córdoba', 'Sofía C. de La Plata', 'Diego R. de Mendoza', 'Luciana M. de CABA', 'Javier T. de Rosario'];
export function FloatingToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(3);
  useEffect(() => {
    const cycleToast = () => {
      // Hide toast
      setIsVisible(false);
      // Wait a bit, then show new toast
      setTimeout(() => {
        setCurrentBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setTimeAgo(Math.floor(Math.random() * 12) + 1);
        setIsVisible(true);
      }, 2000); // 2 seconds hidden
    };
    // Initial show
    setTimeout(() => setIsVisible(true), 3000);
    // Cycle every 10 seconds
    const interval = setInterval(cycleToast, 10000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-96">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-xs bg-[#112240] border border-[#d4a843]/30 rounded-lg shadow-2xl p-4 flex items-start gap-3" data-id="element-97">
          <div className="bg-[#d4a843]/20 p-2 rounded-full shrink-0" data-id="element-98">
            <Bell className="w-5 h-5 text-[#d4a843]" data-id="element-99" />
          </div>
          <div data-id="element-100">
            <p className="text-xs text-[#d4a843] font-semibold mb-1 uppercase tracking-wider" data-id="element-101">
              Compra verificada
            </p>
            <p className="text-sm text-slate-200 leading-tight" data-id="element-102">
              <span className="font-semibold text-white" data-id="element-103">{currentBuyer}</span>{' '}
              compró MegaPack Empleo 📚 hace {timeAgo} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}